import React from 'react';
import PropTypes from 'prop-types';

import { InputGroup, Input, InputGroupAddon, InputGroupText } from 'reactstrap';

import { Field, ErrorMessage } from "formik";
import { CurrentTheme } from "common";
import MagstimInputGroup from './MagstimInputGroup'

const AUTO_COMPLETE_OFF = 'off';

class MagstimInputGroupText extends MagstimInputGroup {


    render() {

        const placeholder = this.props.title.replace('*', '')

        return(
            <>
            <InputGroupAddon addonType="prepend" className="d-md-none d-lg-none prepend-mobile">
                <InputGroupText>{this.props.title}</InputGroupText>
            </InputGroupAddon>
            <InputGroup size={CurrentTheme().ControlSize}>
                <InputGroupAddon addonType="prepend" className="d-none d-md-block">
                    <InputGroupText>{this.props.title}</InputGroupText>
                </InputGroupAddon>
                <Input type={this.props.type} disabled={this.props.disabled} autoComplete={AUTO_COMPLETE_OFF} onFocus={this.onFocus} name={this.props.name} placeholder={placeholder} tag={Field} className={`form-control ${ this.props.touched && this.props.errors ? "is-invalid" : "" }`} />
                <ErrorMessage component="div" name={this.props.name} className="invalid-feedback" />
            </InputGroup>
            </>
        );
    }
}

MagstimInputGroupText.propTypes = {
    title: PropTypes.string,
    name:PropTypes.string,
    touched:PropTypes.bool,
    errors:PropTypes.string,
    disabled:PropTypes.bool,
    type:PropTypes.string
};

MagstimInputGroupText.defaultProps = {
    title: "",
    name:"",
    touched:false,
    errors:undefined,
    disabled:false,
    type:"text"
};

export default MagstimInputGroupText